import { createRoot } from "react-dom/client";
import { bindFolderTreeDragCopyMode, setFolderTreeDragging } from "./folderTreeDrag.js";
function bindJqueryFolderTreeDraggable({ $, target, disabled = false, getDragCount, renderHelper, onTouchEnd }) {
    const $elements = typeof target === "string" ? $(target) : target;
    try {
        $elements.draggable("destroy");
    } catch  {
    // Not initialised yet.
    }
    if (disabled || !$elements.length) {
        return;
    }
    let unbindCopyMode;
    $elements.draggable({
        revert: "invalid",
        revertDuration: 0,
        appendTo: "body",
        cursorAt: {
            top: 0,
            left: 0
        },
        cancel: '[contenteditable="true"],:input',
        distance: 10,
        refreshPositions: true,
        helper: (event)=>{
            const helper = $('<div class="aiot-helper"></div>').appendTo("body");
            createRoot(helper.get(0)).render(renderHelper(getDragCount(event)));
            return helper;
        },
        start: ()=>{
            setFolderTreeDragging($, true);
            unbindCopyMode = bindFolderTreeDragCopyMode($);
            document.activeElement?.blur();
        },
        stop: ()=>{
            setTimeout(()=>{
                setFolderTreeDragging($, false);
                unbindCopyMode?.();
            }, 50);
        }
    });
    if (onTouchEnd) {
        $elements.off("touchend", onTouchEnd).on("touchend", onTouchEnd);
    }
}
export { bindJqueryFolderTreeDraggable };
